import { createTheme, MantineColorsTuple, MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ReactNode } from 'react';
import React from 'react';
import { Provider } from 'react-redux';

import { rootStore } from '../stores';

type Props = {
  children: ReactNode;
};

// Mantine colors generator  #537fc6
const primaryColor: MantineColorsTuple = [
  '#e9f4ff',
  '#d8e5f9',
  '#b3c8e9',
  '#8aa9da',
  '#688ecd',
  '#517ec5',
  '#4576c3', // main
  '#3564ad',
  '#2b599c',
  '#1b4d8b',
];

const theme = createTheme({
  primaryColor: 'primaryColor',
  colors: {
    primaryColor,
    blue: primaryColor,
  },
  headings: {
    fontWeight: '400',
  },
  // TODO
  // spacing
});

export const RootProviders = ({ children }: Props) => {
  return (
    <Provider store={rootStore}>
      <MantineProvider theme={theme}>
        <Notifications limit={2} position="top-center" />
        {children}
      </MantineProvider>
    </Provider>
  );
};
